import { ACLEntityTypeDto } from './aclEntityType.dto';
import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { RoleComponentDto } from './roleComponent.dto';
import { UserDto } from './user.dto';
export class ACLEntityEntryPermissionDto extends BaseDto{  
    entityType: ACLEntityTypeDto;
    entityId: number;
    merchant?: MerchantDto;
    user?: UserDto;
    merchantGroup?: MerchantGroupDto;
    roleComponent?: RoleComponentDto;
    sourceMerchant: MerchantDto;
    sourceUser: UserDto;
    processTag: string;
    read?: boolean;
    write?: boolean;
    enabled?: boolean;
}